import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const rootPaths = [
  '/',
  '/strong-legal-defense',
  '/financials',
  '/leadership',
  '/about'
];

const routes = [
  {
    path: rootPaths[0],
    name: 'Annual Report Home',
    component: Home
  },
  {
    path: rootPaths[1],
    name: 'Strong Legal Defense',
    component: () => import('../views/StrongLegalDefense.vue')
  },
  {
    path: rootPaths[2],
    name: 'Financials',
    component: () => import('../views/Financials.vue'),
    subRoutes: [
      {
        name: 'Highlights',
        path: `${rootPaths[2]}#highlights`
      },
      {
        name: 'Balance Sheets',
        path: `${rootPaths[2]}#balance-sheets`
      },
      {
        name: 'Statements of Income',
        path: `${rootPaths[2]}#statements-of-income`
      },
      {
        name: 'MVP Allocations',
        path: `${rootPaths[2]}#mvp-allocations`
      },
      {
        name: 'MVP Distributions',
        path: `${rootPaths[2]}#mvp-distributions`
      },
      {
        name: 'Policyholders\' Surplus',
        path: `${rootPaths[2]}#policyholders-surplus`
      },
      {
        name: 'Cumulative Dividends',
        path: `${rootPaths[2]}#cumulative-dividends`
      }
    ]
  },
  {
    path: rootPaths[3],
    name: 'Leadership',
    component: () => import('../views/Leadership.vue'),
    subRoutes: [
      {
        name: 'Board of Directors',
        path: `${rootPaths[3]}#board-of-directors`
      },
      {
        name: 'Committees',
        path: `${rootPaths[3]}#committees`
      },
      {
        name: 'Officers',
        path: `${rootPaths[3]}#officers`
      }
    ]
  },
  {
    path: rootPaths[4],
    name: 'About SVMIC',
    component: () => import('../views/About.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    }
  }
});

export default router;
